import api from '@/lib/api';

const upload = (url, file) => {
  const fd = new FormData();
  fd.append('file', file);
  return api.post(url, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
};

export const recuentosAPI = {
  lugares: () => api.get('/recuentos/lugares'),
  misLugares: () => api.get('/recuentos/mis-lugares'),
  updateLugar: (id, data) => api.put(`/recuentos/lugares/${id}`, data),
  ingredientes: (params = {}) => api.get('/recuentos/ingredientes', { params }),
  createIngrediente: (data) => api.post('/recuentos/ingredientes', data),
  updateIngrediente: (id, data) => api.put(`/recuentos/ingredientes/${id}`, data),
  importarIngredientes: (file) => upload('/recuentos/ingredientes/importar', file),
  importarPlantilla: () => api.post('/recuentos/ingredientes/importar-plantilla'),
  plantillaInfo: () => api.get('/recuentos/plantilla/info'),
  descargarPlantilla: () => api.get('/recuentos/plantilla/descargar', { responseType: 'blob' }),
  subirPlantilla: (file) => upload('/recuentos/plantilla', file),
  list: (params = {}) => api.get('/recuentos', { params }),
  estadoSemanal: () => api.get('/recuentos/estado-semanal'),
  create: (data) => api.post('/recuentos', data),
  get: (id) => api.get(`/recuentos/${id}`),
  update: (id, data) => api.put(`/recuentos/${id}`, data),
  validar: (id) => api.get(`/recuentos/${id}/validar`),
  enviar: (id) => api.post(`/recuentos/${id}/enviar?forzar=true`),
  reabrir: (id) => api.post(`/recuentos/${id}/reabrir`),
  marcarSubido: (id) => api.post(`/recuentos/${id}/marcar-subido`),
  remove: (id) => api.delete(`/recuentos/${id}`),
  exportar: (id) => api.get(`/recuentos/${id}/exportar`, { responseType: 'blob' }),
};

export const ESTADOS = {
  borrador: { label: 'Borrador', className: 'bg-slate-100 text-slate-700' },
  enviado: { label: 'Enviado', className: 'bg-blue-100 text-blue-700' },
  exportado: { label: 'Exportado', className: 'bg-amber-100 text-amber-800' },
  subido_justo: { label: 'Subido a Justo', className: 'bg-green-100 text-green-700' },
};

export const ZONAS = ['Cámara / refrigerado', 'Congelados', 'Bodega seca', 'Bebidas', 'Barra', 'Sin zona'];

export const LUGAR_FLAGS = [
  { codigo: 'angamos', field: 'cuenta_angamos', label: 'Angamos' },
  { codigo: 'mall_paseo', field: 'cuenta_mall_paseo', label: 'Mall Paseo' },
  { codigo: 'grecia_principal', field: 'cuenta_grecia_principal', label: 'Grecia Principal' },
  { codigo: 'grecia_central', field: 'cuenta_grecia_central', label: 'Grecia Central' },
];

const TZ = 'America/Santiago';

export const formatFecha = (iso) => {
  if (!iso) return '-';
  const d = new Date(iso);
  const date = d.toLocaleDateString('es-CL', { timeZone: TZ, day: '2-digit', month: '2-digit', year: 'numeric' });
  return date.replace(/\//g, '-');
};

export const formatFechaHora = (iso) => {
  if (!iso) return '-';
  const time = new Date(iso).toLocaleTimeString('es-CL', { timeZone: TZ, hour: '2-digit', minute: '2-digit' });
  return `${formatFecha(iso)} ${time}`;
};

export const parseCantidad = (str) => {
  if (str === null || str === undefined || String(str).trim() === '') return null;
  const n = Number(String(str).trim().replace(',', '.'));
  return Number.isFinite(n) && n >= 0 ? n : NaN;
};

export const fmtNum = (n) => (n === null || n === undefined ? '' : String(n).replace('.', ','));

export const downloadBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const filenameFromHeaders = (headers, fallback) => {
  const cd = headers?.['content-disposition'] || '';
  const m = cd.match(/filename="?([^";]+)"?/);
  return m ? m[1] : fallback;
};

export const errorMsg = (e, fallback) => e?.response?.data?.detail || fallback;
